import { Button, ButtonProps } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";

export default function RegisterButton({ onClick }: ButtonProps) {
  const { t } = useTranslation("components");

  return (
    <Button
      color="primary"
      data-testid="landing__register-btn"
      disableElevation
      fullWidth
      onClick={onClick}
      size="large"
      startIcon={
        <AssignmentTurnedInOutlinedIcon
          style={{ marginRight: "5px", fontSize: "20px" }}
        />
      }
      type="submit"
      variant="contained"
    >
      {t("landing.register")}
    </Button>
  );
}
